import { render, staticRenderFns } from "./status-ctrl.vue?vue&type=template&id=e22c4d1a&scoped=true&"
import script from "./status-ctrl.vue?vue&type=script&lang=js&"
export * from "./status-ctrl.vue?vue&type=script&lang=js&"
import style0 from "./status-ctrl.vue?vue&type=style&index=0&id=e22c4d1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22c4d1a",
  null
  
)

export default component.exports